export enum PATRON_NOTIFICATION_PREFERENCE_TYPE {
  ACCOUNT = 'ACCOUNT',
  AUTO_RENEW = 'AUTO_RENEW',
  CARD_EXPIRE = 'CARD_EXPIRE',
  RECEIPT = 'RECEIPT',
  HOLD = 'HOLD',
  NOTICE = 'NOTICE',
  ITEM_REQUEST = 'ITEM_REQUEST',
  MANDATORY_EMAIL = 'MANDATORY_EMAIL',
  // LOCAL_EVENTS = 'LOCAL_EVENTS',
  // MONTHLY_NEWSLETTER = 'MONTHLY_NEWSLETTER',
}

export class PatronNotificationPreference {
  patronId: number;
  notificationType: PATRON_NOTIFICATION_PREFERENCE_TYPE;
  sendNotification: boolean;
  notifyEmail: boolean;
  notifyText: boolean;
  notifyPhone: boolean;
}
